export const MEASUREMENT_UNITS = [
  "pcs",
  "cm",
  "dz",
  "ft",
  "g",
  "in",
  "kg",
  "lbs",
  "mtr",
  "nos",
  "roll",
  "pkt",
];

export const CURRENCY_TYPES = [
  "us dollar ",
  "Inr ",
  "euro",
  "dirham",
  "chinese",
 
];
export const CURRENCY_DATA = [
  {
    name: "Indian Rupee",
    code: "INR",
    symbol: "₹",
  },
  {
    name: "US Dollar",
    code: "USD",
    symbol: "$",
  },
  {
    name: "Euro",
    code: "EUR",
    symbol: "€",
  },
  {
    name: "UAE Dirham",
    code: "AED",
    symbol: "د.إ",
  },
  {
    name: "Chinese Yuan",
    code: "CNY",
    symbol: "¥",
  },
];